import { phoneInputHandler } from '../../../../templates/main/phoneInputHandler';
import { waveEffect } from '../../../../templates/main/waveEffect';

export const Form = {
    props: {
        variant: {
            type: String,
            default: 'default',
        },
    },
    data: () => ({
        formData: {
            form_text_2: '',
            form_text_3: '',
        },
        spinner: false,
        submited: false,
        countdown: 30,
        intervalId: null,
        phoneError: false,
    }),
    computed: {
        isCardVariant: function () {
            return this.variant === 'card';
        },
    },
    methods: {
        send: function (e) {
            e.preventDefault();

            const phoneNumber = this.formData.form_text_3.replace(/\D/g, '');
            this.phoneError = phoneNumber.length < 9;
            if (this.phoneError) {
                return;
            }

            this.spinner = true;
            BX.ajax.runComponentAction('vv:forms', 'save', {
                mode: 'class',
                data: {data: {fields: this.formData, form_id: 'lizing'}},
            }).then((response) => {
                this.spinner = false;
                if (response.data.status === 'success') {
                    const now = new Date().getTime();
                    localStorage.setItem('lastFormLizingMainPageSubmitTime', now);
                    this.submited = true;
                    this.startCountdown();
                } else {
                    console.error('Ошибка при отправке данных', response.data.message);
                }
            }).catch((error) => {
                this.spinner = false;
                console.error('Ошибка при отправке данных', error);
            });
        },
        handlePhoneInput: function () {
            const phoneNumber = this.formData.form_text_3.replace(/\D/g, '');
            if (phoneNumber.length >= 9) {
                this.phoneError = false;
            }
        },
        handlePhoneBlur: function () {
            const phoneNumber = this.formData.form_text_3.replace(/\D/g, '');
            if (phoneNumber.length > 0 && phoneNumber.length < 9) {
                this.phoneError = true;
            }
        },
        startCountdown: function () {
            if (this.intervalId) {
                clearInterval(this.intervalId);
            }
            this.intervalId = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    this.clearForm();
                }
            }, 1000);
        },
        clearForm: function () {
            localStorage.removeItem('lastFormLizingMainPageSubmitTime');
            clearInterval(this.intervalId);
            this.intervalId = null;
            this.formData = {
                form_text_2: '',
                form_text_3: '',
            };
            this.submited = false;
            this.phoneError = false;
            this.countdown = 30;
        },
    },
    mounted () {
        phoneInputHandler();
        waveEffect();
        const lastSubmitTime = localStorage.getItem('lastFormLizingMainPageSubmitTime');
        if (lastSubmitTime) {
            const now = new Date().getTime();
            const diff = now - lastSubmitTime;
            const remainingTime = 30 - Math.floor(diff / 1000);
            if (remainingTime > 0) {
                this.countdown = remainingTime;
                this.submited = true;
                this.startCountdown();
            } else {
                localStorage.removeItem('lastFormLizingMainPageSubmitTime');
            }
        }
    },
    beforeUnmount () {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    },
    template: `<div :class="['lizing-form-main-page', {'lizing-form-main-page--card': isCardVariant}]">
                    <div v-if="isCardVariant" class="lizing-form-main-page__card">
                        <h2 class="lizing-form-main-page__title">Получить предложение по лизингу</h2>
                        <p class="lizing-form-main-page__subtitle">Перезвоним и подберём условия</p>
                        <form action="" class="form lizing-form-main-page__form" @submit="send" novalidate>
                            <div :class="['form__single', {'form__single--error': phoneError}]">
                                <div class="form__fields">
                                    <div class="form__group">
                                        <label class="lizing-form-main-page__visually-hidden" for="lizing-card-name">Как к Вам обращаться?</label>
                                        <input id="lizing-card-name" type="text" :class="['form__field', {'form__field--disabled': (spinner || submited)}]" v-model="formData.form_text_2" placeholder="Имя" autocomplete="name" :disabled="spinner || submited">
                                    </div>
                                    <div class="form__group">
                                        <label class="lizing-form-main-page__visually-hidden" for="lizing-card-phone">Ваш номер телефона</label>
                                        <input id="lizing-card-phone" type="tel" :class="['form__field', 'js-phone', {'form__field--disabled': (spinner || submited)}, {'form__field--error': phoneError}]" v-model="formData.form_text_3" @input="handlePhoneInput" @blur="handlePhoneBlur" placeholder="+7 (___) ___-__-__" autocomplete="tel" inputmode="tel" aria-required="true" :aria-invalid="phoneError ? 'true' : 'false'" aria-describedby="lizing-card-phone-error" :disabled="spinner || submited">
                                        <div id="lizing-card-phone-error" class="form__message-error" aria-live="polite">{{ phoneError ? 'Укажите номер телефона полностью.' : '' }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="lizing-form-main-page__captcha-slot" data-form-protection-captcha-slot></div>
                            <div class="form__conf"></div>
                            <div class="lizing-form-main-page__action" aria-live="polite">
                                <div v-if="submited" class="form__submited">
                                    <span>Отправлено</span>
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 7.2 5.4 10 11.5 3.8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                </div>
                                <div class="form__sending" v-if="spinner" role="status" aria-label="Заявка отправляется">
                                    <div class="form__spinner" aria-hidden="true"><div></div><div></div><div></div><div></div></div>
                                </div>
                                <button v-if="!spinner && !submited" type="submit" class="form__submit btn">Получить предложение</button>
                            </div>
                            <div v-if="submited" class="form__disabled-time">Форму можно повторно отправить через {{ countdown }} сек.</div>
                        </form>
                    </div>
                    <div v-else class="container">
                        <h2>Оставить заявку на лизинг</h2>
                        <form action="" class="form" @submit="send" novalidate>
                            <div :class="['form__single', {'form__single--error': phoneError}]">
                                <div class="form__fields form__fields--3">
                                    <div class="form__group">
                                        <label class="form__label" for="lizing-default-name">Как к Вам обращаться?</label>
                                        <input id="lizing-default-name" type="text" :class="['form__field', {'form__field--disabled': (spinner || submited)}]" v-model="formData.form_text_2" placeholder="Имя" autocomplete="name" :disabled="spinner || submited">
                                    </div>
                                    <div class="form__group">
                                        <label class="form__label" for="lizing-default-phone">Ваш номер телефона</label>
                                        <input id="lizing-default-phone" type="tel" :class="['form__field', 'js-phone', {'form__field--disabled': (spinner || submited)}, {'form__field--error': phoneError}]" v-model="formData.form_text_3" @input="handlePhoneInput" @blur="handlePhoneBlur" placeholder="+7 (___) ___ __ __" autocomplete="tel" inputmode="tel" aria-required="true" :aria-invalid="phoneError ? 'true' : 'false'" :aria-describedby="phoneError ? 'lizing-default-phone-error' : null" :disabled="spinner || submited">
                                        <div v-if="phoneError" id="lizing-default-phone-error" class="form__message-error" aria-live="polite">Укажите номер телефона полностью.</div>
                                    </div>
                                    <div class="form__group">
                                        <div v-if="submited" class="form__submited">
                                            <span>Отправлено</span>
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 7.2 5.4 10 11.5 3.8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                        </div>
                                        <div class="form__sending" v-if="spinner" role="status" aria-label="Заявка отправляется">
                                            <div class="form__spinner" aria-hidden="true"><div></div><div></div><div></div><div></div></div>
                                        </div>
                                        <button v-if="!spinner && !submited" type="submit" class="form__submit btn">Отправить</button>
                                    </div>
                                </div>
                                <div v-if="submited" class="form__disabled-time">Форму можно повторно отправить через {{ countdown }} сек.</div>
                            </div>
                            <div class="form__conf"></div>
                        </form>
                    </div>
                </div>`,
};
